// extracted by mini-css-extract-plugin
export default {"SQLBox":"SQLBox_SQLBox__rg9uD","list":"SQLBox_list__RYgIZ","listItem":"SQLBox_listItem__s3j2C"};